/**
 * Keys in the `app` namespace. Every screen that filters by a period shows the
 * same two sentences, so the copy is named once here rather than per page.
 */
export const DATE_ORDER_ERROR_KEY = "filters.dateOrder";

export const TIME_ORDER_ERROR_KEY = "filters.timeOrder";

export const RANGE_TOO_LONG_ERROR_KEY = "filters.rangeTooLong";
